import React, { useEffect, useState } from "react";
import GCSerialSelectionModal from "../../../Component/Common/ReuseableComponent/GCSerialSelectionModal";
import {
  SalesInvoice_batchDetailGetRow_GETROW,
  SalesInvoice_deleteDetails_GETROW,
  SalesInvoice_getDetails_GETROW,
  SalesInvoice_invTransDetailBatchIssue_GETROW,
  SalesInvoice_updateDetails_GETROW,
} from "../../../Server/ApiV2";
import { SalesInvoiceRo } from "../../../Redux/roStore";
import { sTrnTyp } from "../SalesInvoiceAction";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../../Utility/Utilitys";
import moment from "moment";
import { Edit } from "@mui/icons-material";

const BatchSelectionModal = ({
  open,
  handleClose,
  SrNo,
  ItemCd = "",
  title = "Serial Selection",
  xDisable,
  SerialDetalModal,
}) => {
  const [availableSerials, setAvailableSerials] = useState([]);
  const [serialInput, setSerialInput] = useState("");
  const [DocumentRow, setDocumentRow] = useState();
  const [selectedSerials, setSelectedSerials] = useState([]);
  const [selectedAvailableIds, setSelectedAvailableIds] = useState([]);
  const [selectedRightIds, setSelectedRightIds] = useState([]);

  const getRowColor = (id) => {
    const foundInRight = selectedSerials.find((serial) => serial.id === id);
    return foundInRight ? "red" : "black"; // Left side shows red if moved
  };

  const isRowDisabled = (id) => {
    return selectedSerials.some((serial) => serial.id === id);
  };
  const fOnLoad = async () => {
    const { HeadObject } = SalesInvoiceRo();
    const payload = {
      v_TrnTyp: sTrnTyp,
      v_VocTyp: HeadObject.A_VocTyp,
      v_VocNo: HeadObject.A_VocNo,
      v_SrNo: SrNo,
    };
    let resp = await SalesInvoice_invTransDetailBatchIssue_GETROW(
      fcheck_null_undefine_replace_empty(payload)
    );
    await fLoad_Grid();
    if (resp?.status === 200) {
      console.log(resp);
      let respData =
        resp?.data?.ResultSet?.length == 0
          ? []
          : resp?.data?.ResultSet.map((obj, i) => ({
              ...obj,
              id: i + 1,
            }));
      setDocumentRow(respData);
    } else {
      setDocumentRow([]);
    }
  };

  const fSrNo = async () => {
    const { HeadObject } = SalesInvoiceRo();

    const payload = {
      v_C_VocTyp: HeadObject.A_VocTyp,
      v_C_VocNo: HeadObject.A_VocNo,
      v_C_SrNo: SrNo,
    };

    let resp = await SalesInvoice_getDetails_GETROW(
      fcheck_null_undefine_replace_empty(payload)
    );

    if (resp?.status === 200) {
      console.log(resp);
      let respData =
        resp?.data?.ResultSet?.length == 0
          ? []
          : resp?.data?.ResultSet.map((obj, i) => ({
              ...obj,
              id: i + 1,
            }));
      setSelectedSerials(respData);
    } else {
      setSelectedSerials([]);
    }
  };
  const fAvailable = async () => {
    const { HeadObject } = SalesInvoiceRo();

    const payload = {
      v_ItmCd: ItemCd, // Item code
      v_Loc: HeadObject.A_Loc, // Location code
      v_BatchNo: 0, // Optional Batch Number (default is 0)
    };

    let resp = await SalesInvoice_batchDetailGetRow_GETROW(
      fcheck_null_undefine_replace_empty(payload)
    );
    if (resp?.status === 200) {
      console.log(resp);
      let respData =
        resp?.data?.ResultSet?.length == 0
          ? []
          : resp?.data?.ResultSet.map((obj, i) => ({
              ...obj,
              id: i + 1,
            }));
      setAvailableSerials(respData);
    } else {
      setAvailableSerials([]);
    }
  };
  const handleSerialSubmit = () => {
    if (!serialInput) {
      fAlertToast("FAILED", "Serial No should not be empty");
      return;
    } else {
      const foundSerial = availableSerials.find(
        (serial) => serial.BatchNo == serialInput
      );

      if (!foundSerial) {
        fAlertToast("FAILED", `Serial No ${serialInput} not found`);
        return;
      } else if (
        foundSerial.BaseQty - foundSerial.Reserved - foundSerial.AlloQty <=
        0
      ) {
        fAlertToast("FAILED", `Insufficient quantity for ${serialInput}`);
        return;
      } else {
        // If everything is fine, update the AlloQty for the matched serial
        const updatedSerials = availableSerials.map((serial) => {
          if (serial.BatchNo == serialInput) {
            return {
              ...serial, // Spread the original object
              AlloQty: serial.BaseQty - serial.Reserved, // Update AlloQty
            };
          }
          return serial; // Return other serials unchanged
        });

        // Update state with the new serials
        setAvailableSerials(updatedSerials);
        // fAlertToast("SUCCESS", `Serial No ${serialInput} processed`);
        setSerialInput("");
      }

      // Update AlloQty if valid
    }
  };

  const fAllocationQty = (params) => {
    if (params.row.BaseQty - params.row.Reserved - Number(params?.value) < 0) {
      // Show an alert or handle the error as needed
      fAlertToast("FAILED", "Quantity exceed than available Quantity");

      return params.row;
    }

    const List = availableSerials?.map((x) => {
      if (x?.id === params.row?.id) {
        x.AlloQty = params.value;
        return x;
      } else {
        return x;
      }
    });
    setAvailableSerials(List);
    params.row.Terms = params.value;

    return params.row;
  };
  // Handle the Enter key press
  const handleKeyPress = (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      handleSerialSubmit();
    }
  };
  const handleClearSelection = (e) => {
    const updatedSerials = availableSerials.map((serial) => {
      return {
        ...serial, // Spread the original object
        AlloQty: 0, // Update AlloQty
      }; // Return other serials unchanged
    });
    // Update the availableSerials with the new data
    setAvailableSerials(updatedSerials);
    setSelectedRightIds([]);
    setSelectedAvailableIds([]);
    setSerialInput("");
  };
  const fLoad_Grid = async () => {
    fSrNo();
    fAvailable();
    setSelectedAvailableIds([]);
    setSelectedRightIds([]);
    setSerialInput("");
  };

  useEffect(() => {
    if (open) {
      setSelectedAvailableIds([]);
      setSerialInput("");
      fOnLoad();
    }
  }, [open]);
  return (
    <GCSerialSelectionModal
      SerialDetalModa={SerialDetalModal}
      xDisable={xDisable}
      handleClearSelection={handleClearSelection}
      handleSerialSubmit={handleSerialSubmit}
      handleKeyPress={handleKeyPress}
      serialInput={serialInput}
      handleSerialInputChange={(e) => {
        setSerialInput(e.target.value);
      }}
      open={open}
      handleClose={handleClose}
      availableSerials={availableSerials}
      setAvailableSerials={setAvailableSerials}
      selectedSerials={selectedSerials}
      setSelectedSerials={setSelectedSerials}
      selectedAvailableIds={selectedAvailableIds}
      setSelectedAvailableIds={setSelectedAvailableIds}
      selectedRightIds={selectedRightIds}
      setSelectedRightIds={setSelectedRightIds}
      handleMoveToLeft={async () => {
        const { HeadObject } = SalesInvoiceRo();

        const selectedRows = selectedSerials.filter((serial) =>
          selectedRightIds.includes(serial.id)
        );

        const payload = {
          v_C_VocTyp: HeadObject.A_VocTyp,
          v_C_VocNo: HeadObject.A_VocNo,
          v_C_SrNo: SrNo,
          rmaDetailsArray: selectedRows.map((obj) => ({
            v_C_RowID: obj.C_RowId,
          })),
        };
        let resp = await SalesInvoice_deleteDetails_GETROW(
          fcheck_null_undefine_replace_empty(payload)
        );
        if (resp?.status === 200) {
          fAlertToast("SUCCESS", "Successfully Deleted");

          console.log(resp);
          await fLoad_Grid();
        }
      }}
      handleMoveToRight={async () => {
        const { HeadObject } = SalesInvoiceRo();
        // Only send the selected rows from availableSerials

        const selectedRows = availableSerials.filter((serial) =>
          selectedAvailableIds.includes(serial.id)
        );
        
        const totalAlloQty = selectedRows.reduce((sum, serial) => {
          return sum + Number(serial.AlloQty);
        }, 0);

        // Check if totalAlloQty exceeds the threshold of 100
        let iQty=DocumentRow.reduce((sum, item) => sum + item.B_Qty, 0)
        if (totalAlloQty > iQty) {
          fAlertToast("FAILED", "Allocation Quantity exceeds batch quantity");
          return false; // Validation failed
        }else{
          const payload = {
            v_C_VocTyp: HeadObject.A_VocTyp,
            v_C_VocNo: HeadObject.A_VocNo,
            Loc: HeadObject.A_Loc,
            v_C_SrNo: SrNo,
            v_C_ItmCd: ItemCd,
            rmaDetailsArray: selectedRows.map((obj) => ({
              v_C_Qty: obj.AlloQty,
              v_C_Unit: "",
              v_C_BaseQty: obj.BaseQty,
              v_C_Narr: "",
              v_C_BatchNo: obj.BatchNo,
              v_C_BatchDt: moment(obj.C_BatchDt).format("YYYY-MM-DD"),
              v_C_ExpDt: moment(obj.C_ExpDt).format("YYYY-MM-DD"),
              v_C_PTyp1: obj.C_PTyp1,
              v_C_PTyp2: obj.C_PTyp2,
              v_C_PTyp3: obj.C_PTyp3,
              v_C_PTyp4: 0,
              v_C_PTyp5: 0,
              v_C_PTyp6: 0,
              v_C_RowID: obj.RowID,
              reserved: obj.Reserved,
            })),
          };
  
          let resp = await SalesInvoice_updateDetails_GETROW(
            fcheck_null_undefine_replace_empty(payload)
          );
          if (resp?.status === 200) {
            fAlertToast("SUCCESS", "Successfully Saved");
  
            console.log(resp);
            await fLoad_Grid();
          }
        }

     
      }}
      DocumentRow={DocumentRow}
      DocumentColumns={[
        { field: "B_Srno", headerName: "Srno", width: 90 },
        { field: "B_Itmcd", headerName: "Item.Code", width: 150 },
        { field: "ItmName", headerName: "Item.Name", width: 250 },
        { field: "B_Qty", headerName: "Qty", width: 100 },
        { field: "UnitName", headerName: "Unit", width: 100 },
        { field: "B_BaseQty", headerName: "BaseQty", width: 100 },
      ]}
      title={title}
      avlColumn={[
        {
          field: "RowID",
          headerName: "Row ID",
          width: 80,
          hide: true,
        },

        {
          field: "C_BatchDt",
          headerName: "MFD",
          width: 80,
          renderCell: (params) => (
            <div style={{ color: getRowColor(params.row.RowID) }}>
              {/* {params.value} */}
              {moment(params.value).format("DD/MM/YYYY")}
            </div>
          ),
          valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
        },
        {
          field: "C_ExpDt",
          headerName: "EXD",
          width: 80,
          renderCell: (params) => (
            <div style={{ color: getRowColor(params.row.RowID) }}>
              {/* {params.value} */}
              {moment(params.value).format("DD/MM/YYYY")}
            </div>
          ),
          valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
        },
        {
          field: "BatchNo",
          headerName: "Card",
          width: 100,
          renderCell: (params) => (
            <div style={{ color: getRowColor(params.row.RowID) }}>
              {params.value}
            </div>
          ),
        },
        {
          field: "C_PTyp1",
          headerName: "Batch No",
          width: 90,
          renderCell: (params) => (
            <div style={{ color: getRowColor(params.row.RowID) }}>
              {params.value}
            </div>
          ),
          // hide: true,
        },
        {
          field: "C_PTyp2",
          headerName: "Product Type 2",
          width: 150,
          renderCell: (params) => (
            <div style={{ color: getRowColor(params.row.RowID) }}>
              {params.value}
            </div>
          ),
          hide: true,
        },
        {
          field: "C_PTyp3",
          headerName: "Product Type 3",
          width: 150,
          renderCell: (params) => (
            <div style={{ color: getRowColor(params.row.RowID) }}>
              {params.value}
            </div>
          ),
          hide: true,
        },
        {
          field: "BaseQty",
          headerName: " Qty",
          width: 50,
          renderCell: (params) => (
            <div style={{ color: getRowColor(params.row.RowID) }}>
              {params.value}
            </div>
          ),
        },
        {
          field: "Reserved",
          headerName: "Reser.",
          width: 50,
          renderCell: (params) => (
            <div style={{ color: getRowColor(params.row.RowID) }}>
              {params.value}
            </div>
          ),
        },
        {
          field: "AlloQty",
          headerName: "Allo.Qty",
          width: 80,
          valueSetter: fAllocationQty,
          editable: true,
          // renderCell: (params) => (
          //   <div style={{ color: getRowColor(params.row.RowID) }}>
          //     {params.value}
          //   </div>
          // ),
        },
        // {
        //   field: "AlloQty",
        //   headerName: "Allo.Qty",
        //   width: 100,
        //   // renderCell: (params) => (
        //   //   <div style={{ color: getRowColor(params.row.RowID) }}>
        //   //     {params.value}
        //   //   </div>
        //   // ),

        // },
      ]}
      srNoColumn={[
        {
          field: "C_BatchDt",
          headerName: "MFD",
          width: 90,
          renderCell: (params) => (
            <div> {moment(params.value).format("DD/MM/YYYY")}</div> // Displaying Manufacture Date (MFD)
          ),
          valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
        },
        {
          field: "C_ExpDt",
          headerName: "EXP",
          width: 90,
          renderCell: (params) => (
            <div> {moment(params.value).format("DD/MM/YYYY")}</div> // Displaying Expiry Date (EXP)
          ),
          valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
        },

        {
          field: "Qty",
          headerName: "Qty",
          width: 90,
          renderCell: (params) => (
            <div>{params.value}</div> // Displaying Quantity
          ),
        },
        {
          field: "C_BatchNo",
          headerName: "Batch.No",
          width: 150,
          renderCell: (params) => (
            <div>{params.value}</div> // Displaying Batch Number
          ),
        },
        {
          field: "C_PTyp1",
          headerName: "P Type 1",
          width: 100,
          renderCell: (params) => (
            <div>{params.value}</div> // Displaying Product Type 1
          ),
          hide: true,
        },
        {
          field: "C_PTyp2",
          headerName: "P Type 2",
          width: 100,
          renderCell: (params) => (
            <div>{params.value}</div> // Displaying Product Type 2
          ),
          hide: true,
        },
        {
          field: "C_PTyp3",
          headerName: "P Type 3",
          width: 100,
          renderCell: (params) => (
            <div>{params.value}</div> // Displaying Product Type 3
          ),
          hide: true,
        },
        {
          field: "C_PTyp4",
          headerName: "P Type 4",
          width: 100,
          renderCell: (params) => (
            <div>{params.value}</div> // Displaying Product Type 4
          ),
          hide: true,
        },
        {
          field: "C_PTyp5",
          headerName: "P Type 5",
          width: 100,
          renderCell: (params) => (
            <div>{params.value}</div> // Displaying Product Type 5
          ),
          hide: true,
        },
        {
          field: "C_PTyp6",
          headerName: "P Type 6",
          width: 100,
          renderCell: (params) => (
            <div>{params.value}</div> // Displaying Product Type 6
          ),
          hide: true,
        },
        {
          field: "C_SrNo",
          headerName: "Serial No",
          width: 100,
          renderCell: (params) => (
            <div>{params.value}</div> // Displaying Serial Number
          ),
          hide: true,
        },
        {
          field: "C_RowId",
          headerName: "Row ID",
          width: 100,
          renderCell: (params) => (
            <div>{params.value}</div> // Displaying Row ID
          ),
          hide: true,
        },
      ]}
    />
  );
};

export default BatchSelectionModal;
